export function formatHealthMessage(message) {
    try {
        const parsed_message = JSON.parse(message)
        return parsed_message["key"] + ", " + parsed_message["message"] + " (" + parsed_message["timestamp"] + ")"
    }
    catch (error) {
        return message
    }
}